import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FeedbackService } from '@karve.it/core';
import { ButtonModule } from 'primeng/button';

import { FeedbackValue } from '../../base/feedback-dialog/feedback-dialog.component';

interface HelpAction {
  label: string;
  icon: string;
  action: () => void;
}

@Component({
  selector: 'app-help-card',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonModule],
  template: `
    <div class="help-list">
      <button
        *ngFor="let a of actions"
        pButton
        type="button"
        [label]="a.label"
        [icon]="a.icon"
        class="p-button-text help-action"
        (click)="a.action()"
      ></button>
    </div>
  `,
  styles: [`
    .help-list {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;
    }
    .help-action {
      justify-content: flex-start !important;
      text-align: left !important;
      padding: 0.5rem 0.75rem !important;
      width: 100%;
      border-radius: 6px;
      color: var(--text-color);

      ::ng-deep .p-button-label {
        font-size: 0.875rem;
      }

      &:hover {
        background: var(--surface-hover);
      }
    }
  `],
})
export class HelpCardComponent {
  actions: HelpAction[] = [
    { label: 'Report a Bug', icon: 'pi pi-exclamation-triangle', action: () => this.openFeedback('bug') },
    { label: 'Send Feedback', icon: 'pi pi-comment', action: () => this.openFeedback('feedback') },
    { label: 'Ask a Question', icon: 'pi pi-question-circle', action: () => this.openFeedback('support') },
    { label: 'Start Support Chat', icon: 'pi pi-comments', action: () => this.openChat() },
  ];

  constructor(private feedbackService: FeedbackService) {}

  openFeedback(type: FeedbackValue): void {
    this.feedbackService.openFeedbackDialog({ feedbackType: type });
  }

  openChat(): void {
    try {
      const Tawk_API = (window as any).Tawk_API;
      if (Tawk_API?.popup) {
        Tawk_API.popup();
      } else if (Tawk_API?.maximize) {
        Tawk_API.maximize();
      }
    } catch {
      // Tawk.to not loaded
    }
  }
}